import { useEffect } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Toaster } from "react-hot-toast";
import { Provider, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import "./ButtonsClasses.scss";
import Layout from "./components/home/Layout";
import Login from "./components/LoginModule/Login";
import store from "./store/Store";

const theme = createTheme({
  palette: {
    primary: { main: "#217E90" },
  },
});

function AppContent() {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  useEffect(() => {
    document.title = "HMIS Clinics";
  }, []);

  return (
    <div className="text-gray-600 text-sm">
      {isLoggedIn ? <Layout /> : <Login />}
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
